import * as React from 'react';
import { fetchApi } from '../../../services/api';
import LoadingPanel from '../../../components/LoadingPanel';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';

type Props = {
  shipmentId: string;
}

type State = {
  loading: boolean;
  rates: CombinedRateAnalysisViewModel[]
}

type GetCombinedRateAnalysisResponse = {
  ShipmentID: string;
  Rates: CombinedRateAnalysisViewModel[];
}

type CombinedRateAnalysisViewModel = {
    VehicleTypeID: number;
    VehicleType: string;
    AverageLinehaulFSC: number;
    AveragePerMile: number;
    MinLinehaul: number;
    AverageLinehaul: number;
    MaxLinehaul: number;
    MinFuel: number;
    AverageFuel: number;
    MaxFuel: number;
    MinDistance: number;
    AverageDistance: number;
    MaxDistance: number;
    OrderCount: number;
}

export default class LoadBoardCombinedRateAnalysis extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      rates: [],
    }

    this.fetch = this.fetch.bind(this);
  }

  public componentDidMount() {
    this.fetch();
  }

  render() {
    if (this.state.loading) {
        return <LoadingPanel />
    }

    return <Grid data={this.state.rates}>
        <GridNoRecords>
          No Rates Found!
        </GridNoRecords>
        <Column field="VehicleType" title="Vehicle Type" />
        <Column field="MinLinehaul" title="AVG Cust LH+FSC" filter="numeric" format="{0:c}" />
        <Column field="AverageLinehaul" title="AVG Cust $/Mile" filter="numeric" format="{0:c}" />
        <Column field="MaxLinehaul" title="AVG Pay LH+FSC" filter="numeric" format="{0:c}" />
        <Column field="MinFuel" title="AVG Pay $/Mile" filter="numeric" format="{0:c}" />
        <Column field="AverageFuel" title="AVG Billed Miles" filter="numeric" format="{0:n0}" />
        <Column field="MaxFuel" title="AVG Gross Margin" filter="numeric" format="{0:c}" />
        <Column field="MinDistance" title="AVG GM%" filter="numeric" format="{0:p}" />
        <Column field="OrderCount" title="Order Count" filter="numeric" />
    </Grid>;
  }

  private fetch() {
    fetchApi('/api/LoadBoard/CombinedRateAnalysis', { ShipmentID: this.props.shipmentId }, 'POST')
      .then((response: GetCombinedRateAnalysisResponse) => {
        this.setState({ loading: false, rates: response.Rates });
      })
  }
}
